const getCssVar = (varName: string): string =>
  window.getComputedStyle(document.body).getPropertyValue(varName);

const getNumericCssVar = (varName: string): number => {
  const cssVar = getCssVar(varName);

  const numericCssVar = parseFloat(cssVar);

  return isFinite(numericCssVar) ? numericCssVar : 0;
};

const setCssVar = (varName: string, value: string): void => {
  const root = document.documentElement;
  root.style.setProperty(varName, value);
};

export { getCssVar, getNumericCssVar, setCssVar };
